import { useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Icon1 from "../icons/Icon";

import { getDocDataById, listenDocDataById } from "../models/DataFunctions";
import NewInvoiceClient from "../pages/NewInvoiceClient";

export default function EmbedWidget({}) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const master_id = searchParams.get("master_id");
  const [success, setSuccess] = useState(false);
  const [widget, setWidget] = useState(null);

  const handleFetchData = async () => {
    try {
      const master = await getDocDataById("org", master_id);
      console.log("master", master);
      if (master) {
        const widget = master.config?.widget || {};

        console.log("widget", widget);

        setWidget(widget);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSetWidget = async () => {
    try {
      const master = await getDocDataById("org", master_id);
      if (master) {
        const widget = master.config?.widget || {};
        setWidget(widget);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    try {
      if (master_id) {
        let unsubscribe = listenDocDataById("org", master_id, (doc) => {
          if (doc) {
            const widget = doc.config?.widget || {};
            setWidget(widget);
          }
        });

        return () => {
          unsubscribe();
        };
      }
    } catch (error) {
      console.error("Error listening to document:", error);
    }
  }, [master_id]);

  useEffect(() => {
    handleFetchData();
  }, []);

  useEffect(() => {
    handleSetWidget();
  }, [master_id]);

  const widgetRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "hexagone:device") {
        setDeviceWidth(event.data.width);
        console.log("deviceWidth", event.data.width);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    window.parent.postMessage(
      { type: "hexagone:toggle", state: isOpen ? "open" : "minimized" },
      "*"
    );
    console.log("toggle", isOpen ? "open" : "minimized");

    function handleClickOutside(event) {
      if (
        widgetRef.current &&
        !widgetRef.current.contains(event.target) &&
        isOpen
      ) {
        setIsOpen(false);
      }
    }

    // Add the event listener when the widget is open
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      console.log("addEventListener", isOpen);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // if phone size show a only available on desktop message
  // get device width and height
  const [deviceWidth, setDeviceWidth] = useState(null);

  const [clicked, setClicked] = useState(false);

  if (widget?.active === false) return <></>;
  if (deviceWidth < 900) {
    return (
      <div
        className="fixed bottom-2 right-2  block bg-transparent pointer-events-auto my-z-index "
        style={{ zIndex: 1000, pointerEvents: "auto" }}
        ref={widgetRef}
      >
        {/* Open/Close Button */}
        {!isOpen ? (
          <button
            style={{
              backgroundColor: widget?.main_color || "#FFF",
              outlineColor: widget?.outline_color || "#93c5fd", // ← works even with hex
            }}
            onClick={() => setIsOpen(true)}
            className={`absolute z-10 bottom-2 right-2

${
  widget?.dark_mode
    ? "text-white border-wshadow_10"
    : "text-black border-shadow_10"
}
hover:scale-105  w-44
  outline-none outline-0 hover:outline-2
 flex flex-col text-left justify-start px-6 py-2 border-1  rounded-full shadow-lg transition-all`}
          >
            <div className="text-h2 "> Créer mon devis</div>
            <div
              className={`text-h4    ${
                widget?.dark_mode ? "text-wshadow_75" : "text-shadow_50"
              }`}
            >
              en 5 minutes
            </div>
          </button>
        ) : (
          <div
            style={{
              width: deviceWidth - 20,
            }}
            className={` ${
              success ? "w-full" : "w-full"
            } border-1 border-shadow_10 max-w-full max-h-[90vh]
          overflow-auto  bg-white rounded-xl shadow-xl p-4 relative`}
          >
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-black text-xl"
            >
              <Icon1 icon_name="close" size={17} />
            </button>

            {success ? (
              <div className="flex flex-col w-full max-w-c300 gap-2 items-start text-left ">
                <Icon1 icon_name="done2" fill="#4dffa6" size={25} />
                <div className="text-h2 font-semibold text-black">
                  Devis créé avec succès
                </div>
                <div className="text-h3 text-gray-500">
                  Vous allez recevoir un email de confirmation.
                </div>

                <div className="text-h3 text-gray-500">
                  Dès que le prestataire aura généré le devis, vous pourrez le
                  signer et le télécharger.
                </div>
              </div>
            ) : (
              <div className="h-full w-full flex flex-col gap-2 min-w-c300">
                {true && (
                  <NewInvoiceClient
                    orgData={{
                      id: "particulier",
                      type: "client",
                    }}
                    iframe={{
                      master_id: master_id,
                      setSuccess: setSuccess,
                      deviceWidth: deviceWidth,
                    }}
                  ></NewInvoiceClient>
                )}
                <div className=" text-h4 ml-auto mr-4 text-shadow_25">
                  Propulsé par{" "}
                  <span className="text-shadow_50 font-semibold">hexagone</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
  if (!master_id)
    return (
      <div className="fixed bottom-8 right-8 z-50 block pointer-events-auto my-z-index">
        {/* Open/Close Button */}
        <div className="bg-white text-red-500 flex flex-col text-left justify-start px-6 py-2 rounded-full shadow-lg hover:outline-2 hover:outline-red-300 outline-none transition-all">
          <div className="text-h3">master_id non renseigné</div>{" "}
        </div>
      </div>
    );

  return (
    <div
      className="fixed bottom-8 right-8  block bg-transparent pointer-events-auto my-z-index "
      style={{ zIndex: 1000, pointerEvents: "auto" }}
      ref={widgetRef}
    >
      {/* Open/Close Button */}
      {!isOpen ? (
        <button
          style={{
            backgroundColor: widget?.main_color || "#FFF",
            outlineColor: widget?.outline_color || "#93c5fd", // ← works even with hex
          }}
          onClick={() => setIsOpen(true)}
          className={`absolute z-10 bottom-4 right-4

${
  widget?.dark_mode
    ? "text-white border-wshadow_10"
    : "text-black border-shadow_10"
}
hover:scale-105  w-44
  outline-none outline-0 hover:outline-2
 flex flex-col text-left justify-start px-6 py-2 border-1  rounded-full shadow-lg transition-all`}
        >
          <div className="text-h2 "> Créer mon devis</div>
          <div
            className={`text-h4    ${
              widget?.dark_mode ? "text-wshadow_75" : "text-shadow_50"
            }`}
          >
            en 5 minutes
          </div>
        </button>
      ) : (
        <div
          className={` ${
            success ? "w-c400" : "w-c800"
          } border-1 border-shadow_10 max-w-full max-h-[90vh]
          overflow-auto  bg-white rounded-xl shadow-xl p-4 relative`}
        >
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-4 right-4 text-gray-400 hover:text-black text-xl"
          >
            <Icon1 icon_name="close" size={17} />
          </button>

          {success ? (
            <div className="flex flex-col w-c300 gap-2 ">
              <Icon1 icon_name="done2" fill="#4dffa6" size={30} />
              <div className="text-h2 font-semibold text-black">
                Devis créé avec succès
              </div>
              <div className="text-h3 text-gray-500">
                Vous allez recevoir un email de confirmation.
              </div>

              <div className="text-h3 text-gray-500">
                Dès que le bureau de contrôle aura accepté le devis, vous
                pourrez le signer et le télécharger.
              </div>
            </div>
          ) : (
            <div className="h-full w-full flex flex-col gap-2">
              <NewInvoiceClient
                orgData={{
                  id: "particulier",
                  type: "client",
                }}
                iframe={{
                  master_id: master_id,
                  setSuccess: setSuccess,
                  deviceWidth: deviceWidth,
                }}
              ></NewInvoiceClient>
              <div className=" text-h4 ml-auto mr-4 text-shadow_25">
                Propulsé par{" "}
                <span className="text-shadow_50 font-semibold">hexagone</span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
